import {
  DELETE_ROLE,
  DELETE_ROLE_FAILURE,
  DELETE_ROLE_PENDING,
  DELETE_ROLE_SUCCESS,
  GET_ROLES,
  GET_ROLES_FAILURE,
  GET_ROLES_PENDING,
  GET_ROLES_SUCCESS,
  ROLES_CLOSE_ADD_MODAL,
  ROLES_CLOSE_EDIT_MODAL,
  ROLES_CLOSE_VIEW_MODAL,
  ROLES_EDIT_MODAL_OPEN_AND_FETCH,
  ROLES_MODAL_SET_ROLE,
  ROLES_OPEN_ADD_MODAL,
  ROLES_VIEW_MODAL_OPEN_AND_FETCH,
  ROLE_EDIT,
  ROLE_EDIT_FAILURE,
  ROLE_EDIT_PENDING,
  ROLE_EDIT_SUCCESS,
  ROLE_SAVE,
  ROLE_SAVE_FAILURE,
  ROLE_SAVE_SUCCESS,
} from "./constants";
const roleActions = {
  getRoles: (payload) => {
    return {
      type: GET_ROLES,
      payload,
    };
  },
  getRolesPending: (payload) => {
    return {
      type: GET_ROLES_PENDING,
      payload,
    };
  },
  getRolesSuccess: (payload) => {
    return {
      type: GET_ROLES_SUCCESS,
      payload,
    };
  },
  getRolesFailure: (payload) => {
    return {
      type: GET_ROLES_FAILURE,
      payload,
    };
  },
  openRolesAddModal: (payload) => {
    return {
      type: ROLES_OPEN_ADD_MODAL,
      payload,
    };
  },
  closeRolesAddModal: (payload) => {
    return {
      type: ROLES_CLOSE_ADD_MODAL,
      payload,
    };
  },
  rolesViewModalStartFetching: (payload) => {
    return {
      type: ROLES_VIEW_MODAL_OPEN_AND_FETCH,
      payload,
    };
  },
  rolesModalSetRole: (payload) => {
    return {
      type: ROLES_MODAL_SET_ROLE,
      payload,
    };
  },
  closeRolesViewModal: (payload) => {
    return {
      type: ROLES_CLOSE_VIEW_MODAL,
      payload,
    };
  },
  closeRolesEditModal: (payload) => {
    return {
      type: ROLES_CLOSE_EDIT_MODAL,
      payload,
    };
  },
  rolesEditModalStartFetching: (payload) => {
    return {
      type: ROLES_EDIT_MODAL_OPEN_AND_FETCH,
      payload,
    };
  },
  // Save Roles

  saveRole: (payload) => {
    return {
      type: ROLE_SAVE,
      payload,
    };
  },
  saveRolesPending: (payload) => {
    return {
      type: ROLE_EDIT_PENDING,
      payload,
    };
  },
  saveRolesSuccess: (payload) => {
    return {
      type: ROLE_SAVE_SUCCESS,
      payload,
    };
  },
  saveRolesFailure: (payload) => {
    return {
      type: ROLE_SAVE_FAILURE,
      payload,
    };
  },

  // Edit Roles

  editRole: (payload) => {
    return {
      type: ROLE_EDIT,
      payload,
    };
  },
  editRolesPending: (payload) => {
    return {
      type: ROLE_EDIT_PENDING,
      payload,
    };
  },
  editRolesSuccess: (payload) => {
    return {
      type: ROLE_EDIT_SUCCESS,
      payload,
    };
  },
  editRolesFailure: (payload) => {
    return {
      type: ROLE_EDIT_FAILURE,
      payload,
    };
  },

  //For delete Role
  deleteRole: (payload) => {
    return {
      type: DELETE_ROLE,
      payload,
    };
  },
  deleteRolePending: (payload) => {
    return {
      type: DELETE_ROLE_PENDING,
      payload,
    };
  },
  deleteRoleSuccess: (payload) => {
    return {
      type: DELETE_ROLE_SUCCESS,
      payload,
    };
  },
  deleteRoleFailure: (payload) => {
    return {
      type: DELETE_ROLE_FAILURE,
      payload,
    };
  },
};
export default roleActions;
